import { errorToast } from "@/lib/toast";

export class FlowError extends Error {
  constructor(description, shouldAlert) {
    super(description);
    this.description = description;
    if (!!shouldAlert) errorToast(description);
  }
}
